import { render, staticRenderFns } from "./RatingBeer.vue?vue&type=template&id=01b90b5d&scoped=true&"
import script from "./RatingBeer.vue?vue&type=script&lang=js&"
export * from "./RatingBeer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b90b5d",
  null
  
)

export default component.exports